import "@hotwired/turbo-rails"
import "@rails/request.js"
import "trix"
import "trix/dist/trix.css"

import '~/controllers'
import Trix from "trix"

document.addEventListener("trix-before-initialize", () => {
    Trix.config.textAttributes.underline = {
        tagName: "u",
        inheritable: true
    }
})

document.addEventListener("trix-initialize", (event) => {
    const toolbar = event.target.toolbarElement
    if (!toolbar) return

    const textTools = toolbar.querySelector(".trix-button-group--text-tools")
    if (!textTools) return

    if (textTools.querySelector('[data-trix-attribute="underline"]')) return

    const button = document.createElement("button")
    button.type = "button"
    button.className = "trix-button underline"
    button.setAttribute("data-trix-attribute", "underline")
    button.setAttribute("title", "Underline")
    button.innerText = "U"

    textTools.appendChild(button)
})

document.addEventListener("turbo:load", () => {
    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.execute === 'function') {
        grecaptcha.ready(() => {
            const key = document.querySelector('meta[name="recaptcha-site-key"]').content;
            const badge = document.querySelector('.grecaptcha-badge');
            if (!badge) { grecaptcha.render({ 'sitekey': key, 'badge': 'bottomright', 'size': 'invisible' }); }
        });
    }
});
